import { entrances, notices } from "@/mocks/chiguaHome";

const statusStyle: Record<string, string> = {
  ok: "bg-emerald-50 text-emerald-700 border-emerald-200",
  busy: "bg-amber-50 text-amber-700 border-amber-200",
  standby: "bg-stone-100 text-stone-600 border-stone-200",
};

const dotStyle: Record<string, string> = {
  ok: "bg-emerald-500",
  busy: "bg-amber-500",
  standby: "bg-stone-400",
};

export default function EntranceBoard() {
  return (
    <section id="entrance" className="scroll-mt-20 bg-[#fbf7f0]">
      <div className="mx-auto w-full max-w-7xl px-4 pb-14 md:px-6">
        {/* 公告栏 */}
        <div className="flex flex-col gap-3 rounded-xl border border-orange-200 bg-orange-50/70 p-4 md:flex-row md:items-center md:gap-4">
          <span className="inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full bg-orange-600 px-3 py-1 text-xs font-bold text-white">
            <i className="ri-megaphone-line"></i> 公告
          </span>
          <ul className="flex min-w-0 flex-col gap-1.5 text-sm text-stone-700">
            {notices.map((n) => (
              <li key={n} className="flex items-start gap-2">
                <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-orange-400"></span>
                <span>{n}</span>
              </li>
            ))}
          </ul>
        </div>

        {/* 入口网格 */}
        <div className="mt-8 flex items-end justify-between gap-4">
          <div>
            <span className="inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-widest text-orange-700">
              <i className="ri-route-line"></i> Access Points
            </span>
            <h2 className="mt-2 text-2xl font-extrabold tracking-tight text-stone-900 md:text-3xl">
              最新可用入口 <span className="text-orange-600">·</span> 逐条切换
            </h2>
          </div>
          <p className="hidden shrink-0 text-sm text-stone-500 md:block">打不开就先换一条，通常秒开</p>
        </div>

        <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {entrances.map((e) => (
            <div key={e.code} className="flex flex-col rounded-xl border border-stone-200 bg-white p-5 transition-colors hover:border-orange-300">
              <div className="flex items-center justify-between">
                <span className="font-mono text-[11px] font-semibold text-stone-400">{e.code}</span>
                <span className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[11px] font-semibold ${statusStyle[e.status]}`}>
                  <span className={`h-1.5 w-1.5 rounded-full ${dotStyle[e.status]}`}></span>
                  {e.statusText}
                </span>
              </div>

              <div className="mt-4">
                <p className="text-sm font-bold text-stone-800">{e.name}</p>
                <p className="mt-1 truncate font-mono text-[13px] text-stone-500">{e.address}</p>
                <p className="mt-2 text-xs text-stone-500">{e.note}</p>
              </div>

              <div className="mt-auto flex items-center gap-2 pt-5">
                <button
                  type="button"
                  className="flex h-9 flex-1 items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-stone-900 text-xs font-semibold text-white transition-colors hover:bg-orange-600"
                >
                  <i className="ri-file-copy-line"></i> 复制地址
                </button>
                <a
                  href="#entrance"
                  className="flex h-9 items-center justify-center gap-1 whitespace-nowrap rounded-md border border-orange-200 bg-orange-50 px-3 text-xs font-semibold text-orange-700 transition-colors hover:bg-orange-100"
                >
                  打开 <i className="ri-external-link-line"></i>
                </a>
              </div>
              <p className="mt-3 text-right text-[11px] text-stone-400">延迟 {e.latency}</p>
            </div>
          ))}
        </div>

        {/* 底部行动区 */}
        <div className="mt-6 flex flex-col gap-3 rounded-xl bg-stone-900 p-5 md:flex-row md:items-center md:justify-between">
          <div className="flex items-center gap-4">
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-orange-600 text-white">
              <i className="ri-download-2-line text-xl"></i>
            </span>
            <div>
              <p className="text-base font-bold text-white">访问不稳定？试试客户端独立通道</p>
              <p className="text-sm text-stone-400">网页入口与客户端数据互通，双端可选更稳妥</p>
            </div>
          </div>
          <div className="flex shrink-0 flex-wrap gap-3">
            <a href="#guide" className="flex items-center gap-1.5 whitespace-nowrap rounded-md bg-orange-600 px-5 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-orange-500">
              <i className="ri-apple-line"></i> iOS
            </a>
            <a href="#guide" className="flex items-center gap-1.5 whitespace-nowrap rounded-md bg-orange-600 px-5 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-orange-500">
              <i className="ri-android-line"></i> Android
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}